import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=d520f946&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"
import style0 from "./HomePage.vue?vue&type=style&index=0&id=d520f946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d520f946",
  null
  
)

export default component.exports